import React from "react";

export enum WidthEnum {
    FitContent = "fit-content",
    FillParent = "100%",
}

interface IRevealAnimationProps {
    children: React.ReactNode;
    width?: WidthEnum;
    reverse?: boolean;
}

// Section content remains visible immediately, including reduced-motion and
// long-page anchor navigation. The hero owns the page's entrance animation.
export const RevealAnimation = ({children, width = WidthEnum.FillParent}: IRevealAnimationProps) => (
    <div style={{width}}>{children}</div>
);
